<template>
  <div>
    <div class="page-head">
      <div>
        <h2>基础服务管理</h2>
        <p>控制小程序基础咨询服务详情、价格和付款下单内容。</p>
      </div>
    </div>

    <el-card shadow="never" v-loading="loading">
      <el-form class="drawer-form" :model="form" label-width="120px">
        <el-form-item label="服务名称"><el-input v-model="form.title" /></el-form-item>
        <el-form-item label="副标题"><el-input v-model="form.subtitle" /></el-form-item>
        <el-form-item label="服务标记"><el-input v-model="form.badge" /></el-form-item>
        <el-form-item label="封面图片"><asset-upload v-model="form.cover_url" category="basic-service" /></el-form-item>
        <el-form-item label="实际价格"><el-input-number v-model="form.price" :min="0" :precision="2" /></el-form-item>
        <el-form-item label="价格展示"><el-input v-model="form.price_text" /></el-form-item>
        <el-form-item label="服务说明"><el-input v-model="form.description" type="textarea" :rows="4" /></el-form-item>
        <el-form-item label="服务流程">
          <el-input v-model="flowText" type="textarea" :rows="4" placeholder="一行一个流程，例如：提交订单" />
        </el-form-item>
        <el-form-item label="服务包含">
          <el-input v-model="includeText" type="textarea" :rows="5" placeholder="一行一个，标题和说明用｜分隔" />
        </el-form-item>
        <el-form-item label="付款须知"><el-input v-model="form.notice" type="textarea" :rows="4" /></el-form-item>
        <el-form-item label="展示状态">
          <el-select v-model="form.status">
            <el-option label="展示中" value="active" />
            <el-option label="已隐藏" value="inactive" />
          </el-select>
        </el-form-item>
      </el-form>
      <div class="drawer-footer">
        <el-button type="primary" :loading="saving" @click="save">保存基础服务</el-button>
      </div>
    </el-card>
  </div>
</template>

<script>
import AssetUpload from "../components/AssetUpload.vue";
import { createResource, listResource, updateResource } from "../api/resources";

export default {
  name: "BasicServiceManage",
  components: { AssetUpload },
  data() {
    return {
      loading: false,
      saving: false,
      flowText: "",
      includeText: "",
      form: this.emptyForm()
    };
  },
  mounted() {
    this.fetchConfig();
  },
  methods: {
    emptyForm() {
      return {
        title: "基础咨询服务",
        subtitle: "唯一付款产品 · 基础咨询服务",
        badge: "咨询服务",
        cover_url: "",
        description: "",
        price: 299,
        price_text: "￥299",
        notice: "",
        status: "active",
        sort_order: 0
      };
    },
    async fetchConfig() {
      this.loading = true;
      try {
        const res = await listResource("basic-service-config", { page: 1, pageSize: 1 });
        const row = res.data && res.data.items && res.data.items[0];
        this.form = { ...this.emptyForm(), ...(row || {}), price: Number(row && row.price ? row.price : 299) };
        this.flowText = this.itemsToText(this.parseJson(this.form.flow_json || this.form.flow));
        this.includeText = this.includesToText(this.parseJson(this.form.include_json || this.form.includes));
      } finally {
        this.loading = false;
      }
    },
    itemsToText(items) {
      const list = Array.isArray(items) ? items : [];
      return list.map((item) => item.name || item.title || item).join("\n");
    },
    parseJson(value) {
      if (!value) return [];
      if (Array.isArray(value)) return value;
      try {
        const parsed = JSON.parse(value);
        return Array.isArray(parsed) ? parsed : [];
      } catch (error) {
        return [];
      }
    },
    includesToText(items) {
      const list = Array.isArray(items) ? items : [];
      return list.map((item) => {
        if (typeof item === "string") return item;
        return [item.title || item.name || "", item.desc || item.description || ""].filter(Boolean).join("｜");
      }).join("\n");
    },
    lines(value) {
      return String(value || "").split("\n").map((item) => item.trim()).filter(Boolean);
    },
    buildPayload() {
      return {
        ...this.form,
        flow_json: this.lines(this.flowText).map((name, index) => ({ index: String(index + 1).padStart(2, "0"), name })),
        include_json: this.lines(this.includeText).map((line) => {
          const [title, desc = ""] = line.split("｜");
          return { title: title.trim(), desc: desc.trim() };
        })
      };
    },
    async save() {
      this.saving = true;
      try {
        const payload = this.buildPayload();
        if (payload.id) await updateResource("basic-service-config", payload.id, payload);
        else await createResource("basic-service-config", payload);
        this.$message.success("基础服务配置已保存");
        this.fetchConfig();
      } finally {
        this.saving = false;
      }
    }
  }
};
</script>
